<template>
	<main-layout>
		<section class="section">
			<div class="container"><slot /></div>
		</section>
	</main-layout>
</template>
<script lang="ts" setup>
import MainLayout from "../layouts/MainLayout.vue";
</script>
